// extracted by mini-css-extract-plugin
export default {"card":"styles_card__i-qQG","label":"styles_label__mZkZZ"};